import React from 'react';
import './FromsMod.scss';

const FromsMod = () => {
  return (
    <div className="main-right-side-section">
      <div className="formsmod-main-section">
        <section>
          <div className="formsmod-section-1">
            <div className="formsmod-section-1-inner">
              <p>Forms Module</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

FromsMod.propTypes = {};

FromsMod.defaultProps = {};

export default FromsMod;
